export default {
  styleOverrides: {
    root: {
      '&:hover': {
        backgroundColor: 'var(--color-action-hover)',
      },

      '&.Mui-selected': {
        backgroundColor: 'var(--color-action-selected)',

        '&:hover': {
          backgroundColor: 'var(--color-action-selected)',
        },
      },
    },
  },
};
